import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Button from "../components/ui/Button";

function HeaderTransparent() {

  const history = useHistory();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  // const [drop, setDrop] = useState(true);
  const matchPathFn = (path) => location.pathname.includes(path);

  useEffect(() => {
    const handleScroll = () => setScrollPosition(window.pageYOffset);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const gotoPage2 = (field) => {
    setIsMobileMenuOpen(false);
    history.push(field ? `/${field}` : "/");
  };

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  // const matchPathFn = (name) => location.pathname === `/assessment/${name}`;

  return (
    <>
      <header className={`flex items-center z-20 top-0 w-full h-20 transition-all ${scrollPosition > 50 ? "bg-white fixed shadow-sm" : "bg-transparent sticky"}`}>
        <nav className="flex justify-between items-center mx-auto px-4 xl:px-0 w-full 2xl:w-9/12 xl:w-11/12 border-b border-[#8A8F87]">
          <div className="flex flex-row items-center gap-4">
            {/* <button onClick={toggleMobileMenu} className="lg:hidden block bg-[#212121]/5 p-2 rounded-full text-[#212121]">
            </button> */}
            <button
              onClick={toggleMobileMenu}
              className={`lg:hidden block bg-[#212121]/5 p-2 rounded-full transition-colors duration-300 ${scrollPosition > 50 ? "text-black bg-[#212121]/5" : "text-white"
                }`}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <line x1="4" y1="6" x2="20" y2="6" />
                <line x1="4" y1="12" x2="20" y2="12" />
                <line x1="4" y1="18" x2="20" y2="18" />
              </svg>
            </button>
            <img
              onClick={() => gotoPage2("")}
              src={
                scrollPosition > 50
                  ? "/assets/logo/AGRPartners-black-logo.svg" // dark logo on white background
                  : "/assets/logo/AGRPartners-Logo.svg" // white logo on transparent bg
              }
              alt="AGR Partners-logo"
              className="w-36 md:w-44 cursor-pointer transition-all duration-300"
            />

            {/* <img onClick={() => gotoPage2("")} src="/assets/logo/AGRPartners-Logo.svg" alt="AGR Partners-logo" className="w-36 md:w-44 cursor-pointer" /> */}
          </div>

          <div className="flex items-center gap-4 md:gap-8">
            <div className={`${isMobileMenuOpen ? "block" : "hidden"} lg:flex lg:items-center gap-8`}>
              <div className="left-0 top-16 lg:top-0 z-40 absolute lg:relative flex lg:flex-row flex-col items-start bg-white lg:bg-transparent shadow-md lg:shadow-none p-6 lg:p-0 border-b lg:border-none w-full lg:w-auto h-screen md:h-auto md:overflow-visible overflow-y-auto">
                <div className="lg:hidden flex justify-between items-center bg-white py-2 w-full h-20">
                  <h1 onClick={() => gotoPage2("/")} className="font-medium text-[#212121] text-xl">Menu</h1>
                  <button onClick={toggleMobileMenu} className="bg-slate-100 p-2 rounded-full">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M18 6l-12 12" />
                      <path d="M6 6l12 12" />
                    </svg>
                  </button>
                </div>

                {/* Desktop View Awardds */}
                <div className="group hidden relative lg:flex justify-between items-center space-x-1 w-full lg:w-auto h-20 text-[#212121] hover:text-[#CB9B2D] text-base cursor-pointer gap-10">

                  <h1 onClick={() => gotoPage2("practiceareas")} className={`flex justify-between items-center text-xl cursor-pointer lg:w-auto w-full lg:h-20 font-semibold transition-colors duration-300 ${matchPathFn("practiceareas")
                    ? "text-[#CB9B2D]"
                    : scrollPosition > 50
                      ? "text-[#212121] hover:text-[#CB9B2D]"
                      : "text-white hover:text-[#CB9B2D]"}`}
                  >
                    Practice Areas
                  </h1>
                  <h1 onClick={() => gotoPage2("sectors")} className={`flex justify-between items-center text-xl cursor-pointer lg:w-auto w-full lg:h-20 font-semibold transition-colors duration-300 ${matchPathFn("sectors")
                    ? "text-[#CB9B2D]"
                    : scrollPosition > 50
                      ? "text-[#212121] hover:text-[#CB9B2D]"
                      : "text-white hover:text-[#CB9B2D]"}`}
                  >Sectors</h1>
                  <h1 onClick={() => gotoPage2("expertise")} className={`flex justify-between items-center text-xl cursor-pointer lg:w-auto w-full lg:h-20 font-semibold transition-colors duration-300 ${matchPathFn("expertise")
                    ? "text-[#CB9B2D]"
                    : scrollPosition > 50
                      ? "text-[#212121] hover:text-[#CB9B2D]"
                      : "text-white hover:text-[#CB9B2D]"}`}
                  >Expertise</h1>

                  {/* <h1 onClick={() => gotoPage2("")} className={`flex justify-between items-center text-xl cursor-pointer lg:w-auto w-full lg:h-20 font-semibold transition-colors duration-300 ${matchPathFn("")
                    ? "text-[#CB9B2D]"
                    : scrollPosition > 50
                      ? "text-[#212121] hover:text-[#CB9B2D]"
                      : "text-white hover:text-[#CB9B2D]"}`}
                  >Partners</h1> */}
                  {/* <h1
                    onClick={() => gotoPage2("")}
                    className={`flex justify-between items-center text-xl cursor-pointer lg:w-auto w-full lg:h-20 font-semibold transition-colors duration-300 ${matchPathFn("")
                        ? ""
                        : scrollPosition > 50
                          ? "text-black hover:text-[#CB9B2D]"
                          : "text-white hover:text-[#CB9B2D]"
                      }`}
                  >
                    Pro Bono
                  </h1> */}
{/* 
                  <h1 onClick={() => gotoPage2("")} className={`flex justify-between items-center text-xl cursor-pointer lg:w-auto w-full lg:h-20 font-semibold transition-colors duration-300 ${scrollPosition > 50 ? "text-black hover:text-[#CB9B2D]" : "text-white hover:text-[#CB9B2D]"}`}>Partners</h1>
                  <h1 onClick={() => gotoPage2("")} className={`flex justify-between items-center text-xl cursor-pointer lg:w-auto w-full lg:h-20 font-semibold transition-colors duration-300 ${scrollPosition > 50 ? "text-black hover:text-[#CB9B2D]" : "text-white hover:text-[#CB9B2D]"}`}>Pro Bono</h1> */}


                  {/* <h1 onClick={() => gotoPage2("practiceareas")}
                    className={matchPathFn("practiceareas") ? "flex justify-between items-center text-xl cursor-pointer text-[#CB9B2D]  lg:w-auto w-full lg:h-20 font-semibold" : "flex justify-between items-center text-xl cursor-pointer hover:text-[#CB9B2D]  text-[#212121]  lg:w-auto w-full lg:h-20 font-semibold"}>Practice Areas{" "}</h1>

                  <h1 onClick={() => gotoPage2("sectors")}
                    className={matchPathFn("sectors") ? "flex justify-between items-center text-xl cursor-pointer text-[#CB9B2D]  lg:w-auto w-full lg:h-20 font-semibold" : "flex justify-between items-center text-xl cursor-pointer hover:text-[#CB9B2D]  text-[#212121]  lg:w-auto w-full lg:h-20 font-semibold"}>Sectors{" "}</h1>

                  <h1 onClick={() => gotoPage2("Expertise")}
                    className={matchPathFn("Expertise") ? "flex justify-between items-center text-xl cursor-pointer text-[#CB9B2D]  lg:w-auto w-full lg:h-20 font-semibold" : "flex justify-between items-center text-xl cursor-pointer hover:text-[#CB9B2D]  text-[#212121]  lg:w-auto w-full lg:h-20 font-semibold"}>Expertise{" "}</h1> */}
                </div>


                {/* mobile view the science*/}
                <div className="lg:hidden flex flex-col justify-start items-start border-transparent border-b-[4px] w-full text-[#212121] hover:text-[#CB9B2D] text-base cursor-pointer">

                  <h1 onClick={() => gotoPage2("practiceareas")}
                    className={matchPathFn("practiceareas") ? "flex justify-between items-center text-xl cursor-pointer mt-4 text-[#CB9B2D]  lg:w-auto w-full font-semibold" : "flex justify-between items-center text-xl cursor-pointer mt-4 hover:text-[#CB9B2D]  text-[#212121]  lg:w-auto w-full font-semibold"}>Practice Areas{" "}</h1>

                  <h1 onClick={() => gotoPage2("sectors")}
                    className={matchPathFn("sectors") ? "flex justify-between items-center text-xl cursor-pointer mt-4 text-[#CB9B2D]  lg:w-auto w-full font-semibold" : "flex justify-between items-center text-xl cursor-pointer mt-4 hover:text-[#CB9B2D]  text-[#212121]  lg:w-auto w-full font-semibold"}>Sectors{" "}</h1>

                  <h1 onClick={() => gotoPage2("expertise")}
                    className={matchPathFn("expertise") ? "flex justify-between items-center text-xl cursor-pointer mt-4 text-[#CB9B2D]  lg:w-auto w-full font-semibold" : "flex justify-between items-center text-xl cursor-pointer mt-4 hover:text-[#CB9B2D]  text-[#212121]  lg:w-auto w-full font-semibold"}>Expertise{" "}</h1>
                  
                  <h1 onClick={() => gotoPage2("")}
                    className={matchPathFn("") ? "flex justify-between items-center text-xl cursor-pointer mt-4 text-[#CB9B2D]  lg:w-auto w-full font-semibold" : "flex justify-between items-center text-xl cursor-pointer mt-4 hover:text-[#CB9B2D]  text-[#212121]  lg:w-auto w-full font-semibold"}>Partners{" "}</h1>
                  
                  <h1 onClick={() => gotoPage2("expertise")}
                    className={matchPathFn("expertise") ? "flex justify-between items-center text-xl cursor-pointer mt-4 text-[#CB9B2D]  lg:w-auto w-full font-semibold" : "flex justify-between items-center text-xl cursor-pointer mt-4 hover:text-[#CB9B2D]  text-[#212121]  lg:w-auto w-full font-semibold"}>Pro Bono{" "}</h1>

                  <div className="md:w-52 w-full flex md:hidden md:mt-0 mt-12 justify-center items-center">
                    <Button text="Let’s Connect" onClick={() => gotoPage2("contact-us")} />
                  </div>

                </div>
              </div>
            </div>

            <div className="md:w-52 w-full block md:flex hidden justify-center items-center">
              <Button text="Let’s Connect" onClick={() => gotoPage2("contact-us")} />
            </div>
          </div>
        </nav>
      </header>
    </>
  );
}
export default HeaderTransparent;